import { FilterDocument } from '@griply/types';
import { buildUpcomingFilterDocument } from '@griply/utils';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

export const useUpcomingFilterDocument = (): FilterDocument => {
  const user = useUser();
  const today = useToday();

  return useMemo(
    () => buildUpcomingFilterDocument(today, user?.settings),
    [today, user?.settings],
  );
};
